import React, { Fragment } from 'react';
import tireRepair from '../../../../images/driverFAQ/tireRepair.png';
import support from '../../../../images/supportticket.png';

const FlatTire = () => (
  <Fragment>
    <p>
      You are responsible for reporting the vehicle’s condition before you
      start your booking and any that occur during your booking. During the
      pre-booking inspection process, you will be prompted to upload photos
      of each side of the vehicle to verify any existing damages. If you
      decide to continue your booking without completing this step, please
      note that you will be liable for any new damages found upon
      inspection.
    </p>

    <p>
      The insurance deductible can reach a maximum of $2,500 unless you
      choose to participate in the reduced deductible plan, then your
      deductible is lowered to $1,000.
    </p>

    <p>
      If you are deemed not at fault, you will not have to pay anything.
    </p>
    <br />
    <h4 className="subtitle">What is covered by Autzu?</h4>
    <ul>
      <li>
        Regularly scheduled maintenance - oil changes, brakes, fluids,
        filters, etc.
      </li>
      <li>
        Mechanical and electrical systems of the vehicle (from regular use)
      </li>
      <li>Tire punctures that are repairable (not side punctures)</li>
      <li>Regular cleaning of exterior and interior</li>
    </ul>
    <br />
    <h4 className="subtitle">What is not covered by Autzu?</h4>
    <ul>
      <li>
        Interior damage (including but not limited to broken charger ports,
        liquid spills that cause electrical damage, holes or tears in
        leather seats)
      </li>
      <li>
        Exterior damage (including but not limited to scratches, scuffs,
        dents, rim damages)
      </li>
      <li>
        Mechanical damage caused by negligence (including but not limited
        to impact with potholes or curbs)
      </li>
      <li>
        Side punctures to tires caused by negligence (including but not
        limited to potholes or curbs)
      </li>
      <li>
        Damage or injuries due to gross negligence (including but not
        limited to phone use while driving, driving too fast, driving under
        the influence)
      </li>
    </ul>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img
        style={{
          width: window.innerWidth < 768 ? '350px' : '750px',
          height: window.innerWidth < 768 ? '95px' : '195px'
        }}
        className="tire-image"
        src={tireRepair}
      />
    </div>
    <p>
      Please note that Autzu covers all tire punctures in the “repairable
      area” for free.
    </p>
    <br />
    <h4 className="subtitle">How to submit a damage report?</h4>
    <ol>
      <li>Open the Autzu app, select Menu > Contact us</li>
      <li>
        Tap “New support” and select{' '}
        <strong>Vehicle > Vehicle is damaged</strong> and submit the
        details We will be sure to respond to you as soon as possible.
      </li>
    </ol>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img src={support} style={{ width: '200px', height: '455px' }} />
    </div>
    <br />
    <h4 className="subtitle">
      I want to open a claim for a cleaning fee with Uber
    </h4>
    <div>
      To request a cleaning fee, you must use the rideshare app to open up
      a claim and submit a photo of the condition of the vehicle along with
      the receipt for the cleaning service within 24 hours of the booking.
      Cleaning fees are charged to Riders to help driver-partners if they
      are unable to continue driving and are required to clean the area
      themselves or access professional cleaning services. In this case,
      Autzu will be responsible for cleaning, and after you have received
      your reimbursement for the cleaning fee, we will apply a deduction
      for a portion of the cleaning fee that you receive.
    </div>
    <br />
    <h4 className="subtitle">How to open up a cleaning claim with Uber</h4>
    <ol>
      <li>Open up the Uber Driver app and select Help</li>
      <li>
        Select Customer and merchant issues {'>'} Issues with a rider {'>'}{' '}
        A rider made a mess in my vehicle {'>'} Fill in the details and
        submit
      </li>
    </ol>
  </Fragment>
);

export default FlatTire;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/FlatTire.js